__turbopack_context__.v({
  "container": "BtvdIG_container",
  "hasPreOrderCheckout": "BtvdIG_hasPreOrderCheckout",
  "navBarSearch": "BtvdIG_navBarSearch",
  "outletDetailsPage": "BtvdIG_outletDetailsPage",
  "spinner": "BtvdIG_spinner",
  "whiteLabeled": "BtvdIG_whiteLabeled",
});
